// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2Q8Rj","footer":"ChangeClinic_footer__2Cq-e"};